<template>
  <Catalogs
    title="Источник исполнителей"
    create-text="Новый"
    :fetch-data="fetchData"
    :fields="fields"
    :route-create="'WorkerSourceAdd'"
    :route-edit="'WorkerSourceEdit'"
    :route-view="'WorkerSourceView'"
    :route-path="'/worker_sources'"
    :can-edit="canEditWorkerSourceCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "WorkerSources",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  data() {
    return {
      fields: [
        {
          key: 'id',
          sortable: true,
          class: 'worker-sources-id'
        },
        {
          key: 'name',
          label: "Название",
          sortable: true,
        },
        {
          key: 'active',
          label: "Активный",
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'action',
          label: "Действия",
          class: 'worker-sources-action'
        },
      ],
    }
  },
  methods: {
    async fetchData(data) {
      return await this.getWorkerSources(data);
    },
    canEditWorkerSourceCatalogs() {
      return this.hasPermission([PERM.CATALOG_WORKER_SOURCE_EDIT]);
    }
  }
}
</script>

<style>
.worker-sources-id {
  width: 60px;
  text-align: center;
}

.worker-sources-action {
  width: 10px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkerSources/WorkerSources.vue